import React, { useState } from "react";
import { useInvitation } from "../../contexts/InvitationContext";
import WeddingLayout from "../../components/WeddingLayout";
import RSVPPage from "../../components/RSVPPage";
import RegistryPage from "../../components/RegistryPage";
import FAQsPage from "../../components/FAQsPage";
import { PHOTO_URLS } from "../../constants/wedding";

const GuestRegistry: React.FC = () => {
  const { invitation } = useInvitation();
  const [activeTab, setActiveTab] = useState<"rsvp" | "registry" | "faqs">(
    "registry"
  );

  const handleTabChange = (tab: string) => {
    if (tab === "rsvp" || tab === "registry" || tab === "faqs") {
      setActiveTab(tab as "rsvp" | "registry" | "faqs");
    }
  };

  const renderActivePage = () => {
    switch (activeTab) {
      case "rsvp":
        return <RSVPPage invitation={invitation} />;
      case "registry":
        return <RegistryPage invitation={invitation} />;
      case "faqs":
        return <FAQsPage invitation={invitation} />;
      default:
        return <RSVPPage invitation={invitation} />;
    }
  };

  return (
    <WeddingLayout
      photoUrl={PHOTO_URLS.GUEST}
      photoAlt="Wedding Guest"
      activeTab={activeTab}
      onTabChange={handleTabChange}
    >
      {renderActivePage()}
    </WeddingLayout>
  );
};

export default GuestRegistry;
